"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

var R = _interopRequireWildcard(require("ramda"));

var _recompose = require("recompose");

var _reactSelect = require("react-select");

var _individual = _interopRequireDefault(require("./individual"));

var _withIcon = _interopRequireDefault(require("./with-icon"));

var _withTag = _interopRequireDefault(require("./with-tag"));

var _defaultOption = _interopRequireDefault(require("./default-option"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CustomOption = function CustomOption(Component) {
  return (0, _recompose.setDisplayName)('CustomOption')(function (_ref) {
    var data = _ref.data,
        props = _objectWithoutProperties(_ref, ["data"]);

    return (0, _core.jsx)(_reactSelect.components.Option, _extends({
      data: data
    }, props), (0, _core.jsx)(Component, {
      icon: data.icon,
      tagLabel: data.tagLabel,
      color: data.color || data.colour,
      url: data.url,
      tooltip: data.tooltip,
      func: data.func,
      isLink: data.isLink,
      qaSelector: "".concat(data.value, " option"),
      label: data.label,
      value: data.value.toString(),
      width: props.theme.iconSize,
      title: data.title,
      data: data,
      hasProfileLink: data.hasProfileLink,
      isSelected: props.isSelected,
      hint: data.hint
    }));
  });
};

var getOptionComp = R.cond([[R.equals('icon'), R.always(_withIcon.default)], [R.equals('tag'), R.always(_withTag.default)], [R.equals('individual'), R.always(_individual.default)], [R.T, R.always(_defaultOption.default)]]);

var _default = function _default(decorator) {
  return CustomOption(getOptionComp(decorator));
};

exports.default = _default;